export const PROVISIONING_IDENTITY_FIELDS = [
  "firstName",
  "lastName",
  "email",
  "password",
  "organizationName",
] as const;

export const PROVISIONING_IDENTITY_LABELS: Record<
  (typeof PROVISIONING_IDENTITY_FIELDS)[number],
  string
> = {
  firstName: "Ad",
  lastName: "Soyad",
  email: "E-posta",
  password: "Şifre",
  organizationName: "Şirket Adı",
};
